<div class="flex flex-column">
  <div
    class="flex align-items-center justify-content-between cursor-pointer hover:surface-100 border-round transition-all transition-duration-150 p-2"
    [ngClass]="{ 'opacity-60': !hasData, 'surface-100 shadow-1': expanded }"
    (click)="toggleExpanded.emit()">
    <div class="flex align-items-center gap-3">
      <div (click)="$event.stopPropagation()" class="flex align-items-center">
        <ng-content select="[poi-left]"></ng-content>
      </div>
      <div class="flex align-items-center gap-2">
        @if (poi.icon) {
          <div
            class="w-2rem h-2rem flex align-items-center justify-content-center border-round bg-primary-50 text-primary">
            <app-svg-icon
              [key]="poi.icon"
              [ngClass]="{ 'opacity-50': !hasData }"></app-svg-icon>
          </div>
        }
        <span
          class="font-bold text-sm"
          [ngClass]="{ 'text-color-secondary italic': !hasData }">
          {{ poi.name }}
        </span>
        @if (!hasData) {
          <i
            class="fas fa-exclamation-triangle text-xs text-orange-400"
            pTooltip="Keine Daten für das gewählte Jahr"
            tooltipPosition="top"></i>
        }
      </div>
    </div>

    <div class="flex align-items-center gap-2 ml-auto">
      <div (click)="$event.stopPropagation()">
        <ng-content select="[poi-right]"></ng-content>
      </div>

      <p-button
        [icon]="expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
        [text]="true"
        [rounded]="true"
        styleClass="p-button-xs"
        (click)="toggleExpanded.emit(); $event.stopPropagation()" />
    </div>
  </div>

  @if (expanded) {
    <div class="ml-2 mt-2 border-left-2 border-primary-100 pl-3 py-1">
      <ng-content select="[poi-content]"></ng-content>
    </div>
  }
</div>
